import type {
  Action,
  ResourceType,
} from '../types';

import * as actionTypes from './actionTypes';

export const requestFullWorkout = ({
  id,
  resourceType,
  addtionalType,
}: {
  id: number,
  resourceType: ResourceType,
  addtionalType?: ResourceType,
}): Action => ({
  type: actionTypes.REQUEST_FULL_WORKOUT,
  id,
  resourceType,
  addtionalType,
});

export const requestLoadPersonalWorkouts = ({
  params,
  userId,
}: {
  params?: any,
  userId: number,
}) => ({
  type: actionTypes.REQUEST_LOAD_PERSONAL_WORKOUTS,
  params,
  userId,
});
